import { AlertOctagon, AlertTriangle, AlertCircle } from 'lucide-react';
import './AlertBanner.css';

function buildAlerts(servers, services, websites) {
  const criticals = [];
  const warnings  = [];
  const minors    = [];

  if (servers?.success) {
    for (const server of servers.data) {
      const st = (server.server_status || '').toLowerCase();
      if (st === 'hors ligne') {
        criticals.push(`Serveur "${server.serveur_name}"`);
      }
      for (const m of (server.metrics || [])) {
        const lvl   = parseInt(m.alerte, 10);
        const label = m.intitule || m.metric_name;
        if (lvl === 4) criticals.push(`${server.serveur_name} — ${label}`);
        if (lvl === 3) warnings.push(`${server.serveur_name} — ${label}`);
        if (lvl === 2) minors.push(`${server.serveur_name} — ${label}`);
      }
    }
  }

  if (services?.success) {
    for (const svc of services.data) {
      if (svc.service_status === 'Hors ligne') criticals.push(`Service "${svc.service_name}"`);
      if (svc.service_status === 'Dégradé')    warnings.push(`Service "${svc.service_name}" dégradé`);
    }
  }

  if (websites?.success && websites.data?.websites) {
    let down = 0, slow = 0;
    for (const s of websites.data.websites) {
      const st = (s.website_status || '').toLowerCase();
      if (st === 'inaccessible' || st === 'hors ligne') down++;
      else if (st === 'ralenti'  || st === 'dégradé')   slow++;
    }
    if (down > 0) criticals.push(`${down} site${down > 1 ? 's' : ''} inaccessible${down > 1 ? 's' : ''}`);
    if (slow > 0) warnings.push(`${slow} site${slow > 1 ? 's' : ''} ralenti${slow > 1 ? 's' : ''}`);
  }

  return { criticals, warnings, minors };
}

function PillGroup({ items }) {
  return (
    <div className="ab-pills">
      {items.map((msg, i) => (
        <span key={i} className="ab-pill">
          <span className="ab-pill-dot" />
          {msg}
        </span>
      ))}
    </div>
  );
}

function AlertCard({ variant, icon, level, count, items }) {
  return (
    <div className="ab-wrap">
      <div className={`ab-card ab-card-${variant}`}>
        <div className="ab-icon-wrap">{icon}</div>
        <div className="ab-content">
          <div className="ab-header">
            <span className="ab-level">{level}</span>
            <span className="ab-count">{count} alerte{count > 1 ? 's' : ''}</span>
          </div>
          <PillGroup items={items} />
        </div>
      </div>
    </div>
  );
}

function AlertBanner({ servers, services, websites }) {
  const { criticals, warnings, minors } = buildAlerts(servers, services, websites);

  if (criticals.length > 0) {
    return (
      <AlertCard
        variant="crit"
        icon={<AlertOctagon size={16} />}
        level="Incidents critiques"
        count={criticals.length}
        items={criticals}
      />
    );
  }

  if (warnings.length > 0) {
    return (
      <AlertCard
        variant="warn"
        icon={<AlertTriangle size={16} />}
        level="Anomalies détectées"
        count={warnings.length}
        items={warnings}
      />
    );
  }

  if (minors.length > 0) {
    return (
      <AlertCard
        variant="minor"
        icon={<AlertCircle size={16} />}
        level="Sous surveillance"
        count={minors.length}
        items={minors}
      />
    );
  }

  return null;
}

export default AlertBanner;
